var objPost = {};



function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function removeNoScroll() {

  if($("body").hasClass("noscroll")) $("body").removeClass("noscroll");

}

function ajaxMethod(obj){

  $.ajax( {
    url: obj.url,
    method: obj.method,
    beforeSend: function ( xhr ) {
        xhr.setRequestHeader( 'X-WP-Nonce', window.nonce );
        xhr.setRequestHeader ("Authorization", "Basic " + btoa("admin" + ":" + "dantokyo"));
    },
    data: obj.data,
    dataType: 'json',
  } ).always( function ( data ) {

    if(obj.callback && !data.responseJSON) {

      obj.callback(data);

    } else {

      console.error(data.responseJSON);

    }

  } );

}


function getURL(path = "") {

  return window.location.origin + "/wp-json/acf/v3/posts/" + $("#detail").data("post-id") + "/" + path;

}

function addObserver(obj) {

  // console.log(obj);
  var io = new IntersectionObserver(obj.callback, obj.options);

  io.POLL_INTERVAL = 100;
  io.observe(obj.target);

}

var bannerRatio = 630/1200;

function doResize(el) {

  if(!el.length) return;

  var w =  $(window).innerWidth();
  el.css({
    height: Math.min(w * bannerRatio, 630)
  })

}

function initPlayer(elPlayer) {
  var player = new Plyr(elPlayer, {
    controls: [
      'play-large',
      'play',
      'progress'
    ]
  });

  player.on('ready', event => {
    console.log("player ready");
  });

  // NOTE: no need play count
  // player.on('ended', event => {
  //   console.log("player ended", objPost);
  //   if(!objPost || !objPost.url) return;
  //   ajaxMethod(objPost);
  // });

  // var hheader = ($("body").hasClass("pc")) ? 110 : 90;
  var hheader = ($("body").hasClass("pc")) ? 40 : 27;
  var hslider = $("#slider").height();
  var ratio =  hheader/hslider;

  addObserver({
    callback: function(e) {

      if (e[0].intersectionRatio <= ratio) {

        $(".plyr--audio").removeClass("fixedPlayer").addClass("fixedPlayer");
        $("#detail .title").removeClass("addPlayerPad").addClass("addPlayerPad");

      } else {

        $(".plyr--audio").removeClass("fixedPlayer");
        $("#detail .title").removeClass("addPlayerPad")

      }

    },
    options: {
      rootMargin: '0px',
      threshold: [ratio]
    },
    target: document.querySelector('#slider')
  });


  // var controller = new ScrollMagic.Controller();
  // var sm = new ScrollMagic.Scene({
  //   triggerElement: "#detail",
  //   offset: -500,
  //   duration: 200
  // })
  //   .on("update", function (e) {
  //     console.log("update", e);
  //   })
  //   .on("enter leave", function (e) {
  //     console.log("enter leave");
  //   })
  //   .on("start end", function (e) {
  //     console.log("start end");
  //   })
  //   .on("progress", function (e) {
  //     console.log("progress", e);
  //   })
  //   .addTo(controller)

  // new ScrollMagic.Scene({
  //           triggerElement: "#trigger1",
  //           triggerHook: 0.9, // show, when scrolled 10% into view
  //           duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
  //           offset: 50 // move trigger to center of element
  //         })
  //         .setClassToggle("#reveal1", "visible") // add class to reveal
  //         .addIndicators() // add indicators (requires plugin)
  //         .addTo(controller);



}



$(document).ready(() => {

  // var hpadding = 40;
  // var hheader = 90;
  //
  // if($("body").hasClass("pc")) {
  //   hpadding = 40;
  //   hheader = 110;
  // }

  // var hheader = ($("body").hasClass("pc")) ? 110 : 90;
  // var hslider = $("#slider").height();

  // addObserver({
  //   callback: function(e) {
  //
  //     console.log("addObserver:", e[0].isIntersecting);
  //
  //     var hh = hheader;
  //
  //     if(!e[0].isIntersecting) hh -= hpadding;
  //
  //     anime({
  //       targets: document.getElementById("header"),
  //       height: hh,
  //       easing: 'easeInOutExpo',
  //       duration: 800
  //     });
  //
  //   },
  //   options: {
  //     // rootMargin: '-100px',
  //     // rootMargin: "-" + (hslider) + "px 0px 0px 0px",
  //     // threshold: 1
  //   },
  //   target: document.querySelector('#trigger')
  // })

  var elPlayer = document.getElementById('player');
  if(elPlayer) {

    initPlayer(elPlayer);

    // var objGet = {
    //   method: "GET",
    //   url: getURL("audio"),
    //   callback: function(data) {
    //
    //     initPlayer(elPlayer);
    //
    //     var audio = data["audio"];
    //     if(!audio || !audio.length) return;
    //
    //     var audioID = $("#player").data("id");
    //     var audioData = _.map(audio, function(v) {
    //       if(v.track_file.ID == audioID) {
    //
    //         if(!v.track_count.length) {
    //
    //           v.track_count = 1;
    //
    //         } else {
    //
    //           v.track_count = parseInt(v.track_count) + 1;
    //
    //         }
    //
    //       }
    //
    //       return v;
    //     })
    //
    //     objPost = {
    //       method: "POST",
    //       data: {
    //         "fields": {
    //           audio: audioData
    //         }
    //       },
    //       url: getURL(),
    //       callback: function(data) {
    //         console.log("DONE!", data);
    //       }
    //     }
    //
    //   }
    // }
    //
    // // Step 1 Fetch ARRAy
    // ajaxMethod(objGet);

  }

  var element = document.getElementById('slider');
  var resBanner = $('.banner');
  var swiperBanner = $('#slider .swipe-wrap div');
  var nav = document.getElementById("main-nav");
  var allElements = document.getElementsByClassName("wrapper");

  var isClose = true;

  $( "#js-burger" ).click(() => {

    if(!isClose) return;
    isClose = false;

    var w = -$(window).width();

    removeNoScroll();

    $("body").addClass("noscroll");

    anime({
      targets: nav,
      translateX: w,
      easing: 'easeInOutExpo'
    });

    anime({
      targets: allElements,
      translateX: w,
      easing: 'easeInOutExpo'
    });


  });

  $( "#js-close" ).click(() => {

    if(isClose) return;
    isClose = true;

    removeNoScroll();

    anime({
      targets: nav,
      translateX: 0,
      easing: 'easeOutExpo',
      duration: 500
    })

    anime({
      targets: allElements,
      translateX: 0,
      easing: 'easeOutExpo',
      duration: 500,
      complete: function(anim) {
        if(anim.completed) {
          $(".wrapper").attr("style", "");
        }
      }
    });

  });

  $( window ).resize(function() {
    doResize(resBanner);
    doResize(swiperBanner);
  })
  doResize(resBanner);
  doResize(swiperBanner);

	if(element) {

		window.mySwipe = new Swipe(element, {
			startSlide: 0,
			auto: 3000,
			draggable: true,
			autoRestart: false,
			continuous: true,
			disableScroll: true,
			stopPropagation: true,
			callback: function(index, element) {

        $( "#js-swipe-number span" ).text(index + 1);

        var sc = "js-swiper-" + index;

        $('.swipe-menu > a').each(function () {

          var el = $(this);

          if(el.attr("id") === sc) {

            el.removeClass("swipe-selected").addClass("swipe-selected");

          } else {

            if(el.hasClass("swipe-selected")) el.removeClass("swipe-selected")

          }

        });

      },
			transitionEnd: function(index, element) {

      }
		});

    $('.swipe-menu > a').click(function() {
      var index = $(this).data("id");
      window.mySwipe.slide(index, 200)
    });
	}

});
